module.exports = __webpack_public_path__ + "img/fcldcgq1.5ee957fa.png";